import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { TiInfoLargeOutline } from "react-icons/ti";
import { MdOutlineDashboard } from "react-icons/md";
import { RiContactsLine } from "react-icons/ri";
import { GrAchievement } from "react-icons/gr";
import { MdWork } from "react-icons/md";

const MenuItem = ({ to, icon, text, isActive }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      className={`${
        " " + (isActive ? " bg-indigo-500 border  rounded-lg scale-105 font-bold" : "")
      } flex flex-col  items-center  text-white  p-2 justify-center transition-all duration-300`}
    >
      <NavLink className="flex flex-col items-center justify-center" to={to}>
        {icon}
        {text}
      </NavLink>
    </motion.div>
  );
};

const Menu = () => {
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState(location.pathname);

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex justify-end xs:justify-center items-center w-full">
      <motion.div
        initial={{ opacity: 0, y: 0, x: 500 }}
        animate={{ opacity: 1, y: 0, x: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-stone-800 font-poppins flex-wrap h-fit rounded-lg flex shadow-2xl justify-center items-center transition-all duration-300"
      >
        <MenuItem
          to={"/"}
          icon={<TiInfoLargeOutline />}
          text={"About"}
          isActive={currentPath === "/"}
        />
        <MenuItem
          to={"/projects"}
          icon={<MdOutlineDashboard />}
          text={"Projects"}
          isActive={currentPath === "/projects"}
        />
        <MenuItem
          to={"/achievements"}
          icon={<GrAchievement />}
          text={"Feats"}
          isActive={currentPath === "/achievements"}
        />
        {/* <MenuItem
          to={"/works"}
          icon={<MdWork />}
          text={"Works"}
          isActive={currentPath === "/works"}
        /> */}
        <MenuItem
          to={"/contact"}
          icon={<RiContactsLine />}
          text={"Contact"}
          isActive={currentPath === "/contact"}
        />
      </motion.div>
    </div>
  );
};

export default Menu;
